import { msgConstants, errorMessageConstants } from "../constants";

export function msg(state = {}, action) {
  switch (action.type) {
    case msgConstants.SUCCESS:
      return {
        type: "success",
        header: action.header,
        message: action.message
      };
    case msgConstants.ERROR:
      return {
        type: "danger",
        header: action.header,
        errorCb: action.errorCb,
        message:
          errorMessageConstants[action.message] ||
          (action.unknown ? "Unknown error: " + action.message : action.message)
      };
    case msgConstants.CLEAR:
      if (state.errorCb) state.errorCb();
      return {};
    default:
      return state;
  }
}
